import ReactECharts from 'echarts-for-react';
import { useEffect, useState } from 'react';
import { MoreOutlined,CloseOutlined } from '@ant-design/icons';
import { Button, DatePicker, Dropdown, Modal, Space } from 'antd';
import dayjs from 'dayjs';
import { getAdjustedDate, isExactMultipleOfOneHour } from '../CommonFunctions';
import { ConvertHourlyDataForBarChart, GetCategoriesFromHourlyData } from '../chartdata.transformers';
import { useStoreUpdaterWithAPI } from '../../../Hooks/UseStoreUpdaterWithApi';
import { APIConstants } from '../../../Common/APIConstants';
import { adjustTimeByFiveHoursThirtyMinutes, calculateDateRangeFromDate } from '../../../Utils/DateConverstion';

const { RangePicker } = DatePicker;

export default function BarChart(props) { 
    const title = props.title;
    const theme = props.theme; 
    const [data, setData] = useState([
        {
            groupConsumption: 0,
            groupID: 0,
            groupMinusMeterConsumption: 0,
            groupName: 'No Data Available',
            fromDateTime: 'No Data Available',
            toDateTIme: 'No Data Available',
            groupPlusMeterConsumption: 0
        },
        {
            groupConsumption: 1,
            groupID: 0,
            groupMinusMeterConsumption: 0,
            groupName: 'No Data Available',
            fromDateTime: 'No Data Available',
            toDateTIme: 'No Data Available',
            groupPlusMeterConsumption: 0
        }
    ]); 
    const [series, setSeries] = useState();
    const [categories, setCategories] = useState();
    const { makeRequest } = useStoreUpdaterWithAPI();
    const [error, setError] = useState('');
    const correctDate = new Date(getAdjustedDate());

    const defaultFromDate = dayjs(correctDate).hour(6).minute(30).second(0);
    const defaultToDate = defaultFromDate.add(24, 'hours');

    const [fromDate, setFromDate] = useState(defaultFromDate);
    const [toDate, setToDate] = useState(defaultToDate);
    const [refetch, setRefetch] = useState(false);
    const [loading, setLoading] = useState(true); // New loading state
    const [open, setOpen] = useState(false);

    // Function to update the component every 30th minute
    const updateAt30thMinute = () => { 
      const now = new Date();
      const minutes = now.getMinutes();
      const millisecondsUntilNext30thMinute = 
        (minutes < 30 
          ? (30 - minutes) * 60 * 1000 
          : (60 - minutes + 30) * 60 * 1000
        ) - (now.getSeconds() * 1000 + now.getMilliseconds());
      
      setTimeout(() => {
        updateAt30thMinute(); // Recursively set the timeout for the next update
      }, millisecondsUntilNext30thMinute);
    };
  
    useEffect(() => {
      updateAt30thMinute(); 
    }, []);


    const onRangeChange = (dates, dateStrings) => {
        if (dateStrings) {
            const start = new Date(dateStrings[0]);
            const end = new Date(dateStrings[1]);

            const diffMinutes = isExactMultipleOfOneHour(start, end);
            if (!diffMinutes) {
                setError(true);
            } else {
                setError(false);
                setFromDate(start);
                setToDate(end);
                setLoading(true);
                setRefetch(!refetch);
            }
        } else {
            console.log('Date range cleared');
        }
    };

    const rangePresets = [
        {
            label: 'Last 7 Days',
            value: [dayjs().subtract(7, 'days').hour(6).minute(30).second(0), dayjs().hour(6).minute(30).second(0)],
        },
        {
            label: 'Last 14 Days',
            value: [dayjs().subtract(14, 'days').hour(6).minute(30).second(0), dayjs().hour(6).minute(30).second(0)],
        },
        {
            label: 'Last 30 Days',
            value: [dayjs().subtract(30, 'days').hour(6).minute(30).second(0), dayjs().hour(6).minute(30).second(0)],
        },
        {
            label: 'Last 90 Days',
            value: [dayjs().subtract(90, 'days').hour(6).minute(30).second(0), dayjs().hour(6).minute(30).second(0)],
        },
    ];

    const getReposnse =async () => {
        const currentDate = new Date();
        const { from, to } = calculateDateRangeFromDate(currentDate, 31, 30);

        const inputData = {
            FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),  
            ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
        }; 

        // try {      
        //     makeRequest({
        //         type: APIConstants.GET,         
        //         url: `${APIConstants.LUCAS_LIVE_HOURLY_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`
        //     }).then((res) => {   
        //         if(res && res.length > 0){
        //             setData(res); 
        //             setSeries(ConvertHourlyDataForBarChart(res));
        //             setCategories(GetCategoriesFromHourlyData(res));
        //         }
        //     });
        // } catch (error) {
        //     console.log(error);
        // }      
        try {      
            const res = await makeRequest({
              type: APIConstants.GET, 
              url: `${APIConstants.LUCAS_LIVE_HOURLY_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`
            });
            if(res && res.length > 0){
                setData(res); 
                setSeries(ConvertHourlyDataForBarChart(res));
                setCategories(GetCategoriesFromHourlyData(res));
            }
          } catch (error) {
            console.log(error);
          } finally {
            setLoading(false); // Stop loading
          } 
    };    
    
    useEffect(() => { 
        getReposnse();
    }, [refetch]); 
    console.log(categories)

    const items = [
        {
          label: (
            <p className="" onClick={() => setOpen(!open)}>
              TV
            </p>
          ),
          key: "0",
        },
        {
          label: <p> Other Option</p>,
          key: "1",
        },
        // {
        //   type: 'divider',
        // },
      ];

      console.log(series)
    return (
        <div className='w-full shadow-allsides'>
            <div className='border-b w-full flex justify-between' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 className={`${theme === 'dark' ? "text-neutral-100" : 'text-neutral-600'} md:text-2xl px-3 font-bold`} style={{ margin: 0 }}>{title}</h2>
                <Dropdown
                    menu={{
                    items,
                    }}
                    trigger={['click']} 
                    arrow>
                    <a onClick={(e) => e.preventDefault()}>
                    <Space>
                        <MoreOutlined className={`${theme === 'dark' ? "text-neutral-100" : 'text-neutral-600'} p-3 font-extrabold`} />
                    </Space>
                    </a>
                </Dropdown>
                {/* <button >
                </button> */}
            </div> 

            {loading ? (
        <div className="flex justify-center items-center w-full h-[200px]">
          <p className="text-white">Loading...</p>
        </div>
      ) : (
        <>

        <ReactECharts
        className='h-full'
        style={{ height: '280px' }} 
        option={{
            toolbox: {
                show: true,
                feature: {
                //   dataZoom: {
                //     yAxisIndex: 'none'
                //   },
                //   dataView: { readOnly: false },
                  magicType: { type: ['line', 'bar'] },
                //   restore: {},
                  saveAsImage: {}
                }
              },
            xAxis: {
                type: 'category',
                data: categories,
                axisLabel: {
                    interval: 'auto', // Automatically determine interval to avoid overlap
                    rotate: 45, // Rotate labels 45 degrees
                    formatter: function (value) {
                        // Customize the label if necessary
                        return value.length > 10 ? value.substring(0, 10) + '...' : value;
                    }
                }
            }, 
            yAxis: {
                type: 'value',
                splitLine: {
                    show: false, // This hides the horizontal grid lines
                  },
            },
            series: series,
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            }
        }}
    />
      <Modal
            title={
              <div
                className={`bg-${
                  theme === "dark" ? "slate-950" : "white"
                } text-${theme === "dark" ? "white" : "black"} px-4 py-2`}
              >
                TV mode
              </div>
            }
            centered
            open={open}
            footer={null}
            onCancel={() => setOpen(false)}
            width="1350 "
            className="bg-red-700"
            style={{
              padding: 0,
              top: 0,
              backgroundColor: theme === "dark" ? "#1e293b" : "#ffffff",
              color: theme === "dark" ? "#f0f0f0" : "#000000",
            }}
            closeIcon={
              <div
                className={`bg-${
                  theme === "dark" ? "slate-950" : "white"
                } text-${
                  theme === "dark" ? "white" : "black"
                } p-0 mt-0 rounded-full`}
              >
                <CloseOutlined />
              </div>
            }
          >
            <div
              className={`${
                theme === "dark" ? "bg-slate-950" : "bg-slate-100"
              }`}
            >
               <ReactECharts
        className='h-full'
        style={{ height: "900px", width: "1300px" }} 
        option={{
            toolbox: {
                show: true,
                feature: {
                //   dataZoom: {
                //     yAxisIndex: 'none'
                //   },
                //   dataView: { readOnly: false },
                  magicType: { type: ['line', 'bar'] },
                //   restore: {},
                  saveAsImage: {}
                }
              },
            xAxis: {
                type: 'category',
                data: categories,
                axisLabel: {
                    interval: 'auto', // Automatically determine interval to avoid overlap
                    rotate: 45, // Rotate labels 45 degrees
                    formatter: function (value) {
                        // Customize the label if necessary
                        return value.length > 10 ? value.substring(0, 10) + '...' : value;
                    }
                }
            }, 
            yAxis: {
                type: 'value',
                splitLine: {
                    show: false, // This hides the horizontal grid lines
                  },
            },
            series: series,
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            title: {
                text: title,
                left: "2px",
                padding: 10,
                // textStyle: getTitleStyle(),
              },
        }}
        />
            </div>
          </Modal>
    
        </>
      )}
           
            <div className=" justify-center items-center w-full pt-[0px] flex ">
                <p className='bg-transparent w-fit p-2 md:mb-2 text-white '>
                    <RangePicker
                        presets={[
                            {
                                label: <span aria-label="Current Time to End of Day">Now ~ EOD</span>,
                                value: () => [dayjs(), dayjs().endOf('day')],
                            },
                            ...rangePresets,
                        ]}
                        showTime
                        format="YYYY/MM/DD HH:mm:ss"
                        defaultValue={[defaultFromDate, defaultToDate]}
                        className={`customRangePicker ${error ? "errorInDate" : ""} ${theme === 'dark' ? 'customRangePicker-dark' : 'customRangePicker-light'} `}
                        onChange={onRangeChange} 
                        disabledDate={current => {
                          const tomorrowEnd = dayjs().add(1, 'day').endOf('day');
                          return current && current > tomorrowEnd;
                        }}
                    />
                    {error && (
                        <p className='text-white font-bold border-b-2 border-red-500'>
                            The selected time range must be at least 60 minutes or multiple of 60 minutes.
                        </p>
                    )}
                </p>
            </div>
        </div>
    );
}
